module.exports = __webpack_public_path__ + "media/img/payments/credit-card-39eab443572e7aae1e52b30a7807f9e3.jpg";